export const chartsColors = [
  "red",
  "green",
  "yellow",
  "purple",
  "darkred",
  "Aqua",
  "Aquamarine",
  "white",
  "Beige",
  "Chocolate",
  "Coral",
  "CornflowerBlue",
  "DarkTurquoise",
  "Crimson",
  "darkgrey",
  "DarkCyan",
  "DarkGoldenRod",
  "cyan",
  "DarkKhaki",
  "DarkOrchid",
  "DarkSalmon",
  "DarkViolet",
  "DodgerBlue",
  "Gold",
  "GreenYellow",
  "HotPink",
  "IndianRed",
  "lime",
  "GoldenRod",
  "LightSalmon",
  "LightSeaGreen",
  "indigo",
  "Tomato",
  "SandyBrown",
  "RebeccaPurple",
  "Fuchsia",
  "Orchid",
  "MediumSpringGreen",
  "LightPink",
  "Chartreuse"
];

export const chartsTitles = [
  "lng_charts_0",
  "lng_charts_1",
  "lng_charts_2",
  "lng_charts_3"
];

export const chartsHours = ["1", "3", "6", "12", "24", "48"];
